import { getUserInfo } from '@/apis/auth/user';
import { getMenuInfo } from '@/apis/memInfo/memInfo';
import { saveLogInfo } from '@/apis/logInfo';
import Utils from '@/utils/utils';
function treeToArr(data, parentId = null, res = []) {
  data.forEach(item => {
    let name = item.name;
    if (item.parentId && item.parentId != '1') {
      let parentName = res.find(node => node.id == item.parentId)?.name;
      name = parentName + '_' + name;
    }
    res.push({ parentId, perms: item.perms || '', name, id: item.id });
    if (item.listMenu && item.listMenu.length > 0) {
      treeToArr(item.listMenu, item.id, res);
    }
  });
  return res;
}
const state = {
  userInfo: JSON.parse(localStorage.getItem('USER_INFO')) || {}
};
const getters = {
  userInfo: state => state.userInfo
};

const mutations = {
  setDeatail(state, data) {
    state.userInfo = data;
    localStorage.setItem('USER_INFO', JSON.stringify(data));
  }
};
const actions = {
  updateUserInfo: ({ commit }, payload) => {
    return new Promise(async (resolve, reject) => {
      let token = '';
      if (isCenter()) {
        token = Utils.getUrlParam().token || sessionStorage.getItem('TOKEN');
      } else {
        token = Utils.getToken();
      }
      let res = await getUserInfo({ token });
      commit('setDeatail', res);
      let { listMenu = [] } = await getMenuInfo({ page: { pageNum: 1, pageSize: 500 } });
      let menuInfoArr = treeToArr(listMenu, '1', []);
      localStorage.setItem('MENU_INFO', JSON.stringify(menuInfoArr));
      if (!isCenter() && process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'testenviroment') {
        let { userName, userOrgName, userId, userOrgId,orgCode } = res;
        let params = {
          userId: userId,
          path: 'login',
          name: '用户登录',
          userName,
          userOrgName,
          userOrgId,
          orgCode,
          startTime: Utils.dateFormat(new Date(), 'YYYY-MM-DD hh:mm:ss'),
          endTime: '',
          type: 'login'
        };
        await handleLogLogin(params);
      }
      resolve();
    });
  }
};
function isCenter() {
  let urlType = Utils.getUrlParam().urlType || sessionStorage.getItem('URL_TYPE');
  if (urlType === 'center') {
    return true;
  } else {
    return false;
  }
}
function handleLogLogin(params) {
  return new Promise(async (resolve, reject) => {
    await saveLogInfo({ logInfo: params });
    resolve();
  });
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
